const baseUrl = process.env.BASE_URL;
console.log(baseUrl);

function getFaviconTags():{
	icon:HTMLLinkElement,
	appleTouchIcon:HTMLLinkElement,
	icon32:HTMLLinkElement,
	icon16:HTMLLinkElement
	}{
	let result = {
		icon: null as any as HTMLLinkElement,
		appleTouchIcon: null as any as HTMLLinkElement,
		icon32: null as any as HTMLLinkElement,
		icon16: null as any as HTMLLinkElement
	};

	let linkTags = document.head.getElementsByTagName("link");
	for (let tag of linkTags) {
		if (tag.rel == "icon"){
			if (tag.sizes.length == 0){
				result.icon = tag;
			}else if (tag.sizes.contains("32x32")){
				result.icon32 = tag;
			}else if (tag.sizes.contains("16x16")){
				result.icon16 = tag;
			}
		}else if (tag.rel == "apple-touch-icon"){
			result.appleTouchIcon = tag;
		}
	}
	return result;
}

export function setFaviconDefault(){
	let tags = getFaviconTags();
	tags.icon.href = `${baseUrl}ico/favicon.ico`;
	tags.appleTouchIcon.href = `${baseUrl}ico/apple-touch-icon.png`;
	tags.icon32.href = `${baseUrl}ico/favicon-32x32.png`;
	tags.icon16.href = `${baseUrl}ico/favicon-16x16.png`;
}

export function setFaviconNotification(){
	let tags = getFaviconTags();
	tags.icon.href = `${baseUrl}ico/favicon-notification.ico`;
	tags.appleTouchIcon.href = `${baseUrl}ico/apple-touch-icon-notification.png`;
	tags.icon32.href = `${baseUrl}ico/favicon-notification-32x32.png`;
	tags.icon16.href = `${baseUrl}ico/favicon-notification-16x16.png`;
}